import React from "react";
import CartButtonsPDP from "./CartButtonsPDP";
import PriceInfoPDP from "./PriceInfoPDP";
import PriceTagPDP from "./PriceTagPDP";

const CartBlockPDP = (props) => {
  const {product, className = ""} = props;

  return <div
    className={`
      cart-block-pdp
      border-radius-xl
      border-default
      border-color-light
      padding-top-30
      padding-left-20
      padding-bottom-20
      padding-right-20
      ${className}
    `}
  >
    <PriceTagPDP product={product}/>
    <CartButtonsPDP product={product} className="margin-top-20"/>
    {product?.available_to_add_to_cart && <PriceInfoPDP product={product}/>}
  </div>;
};

export default CartBlockPDP;
